import React from "react";
import { FaTimes, FaCode } from "react-icons/fa";

function PayloadModal({ title, payload, onClose }) {
  if (!payload) return null;

  return (
    <div className="topmate-modal-overlay" onClick={onClose}>
      <div className="topmate-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "650px" }}>
        <div className="modal-header">
          <h3>
            <FaCode style={{ color: "#38bdf8" }} /> {title || "Webhook Payload"}
          </h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close modal">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <pre
            style={{
              background: "#090d16",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "10px",
              padding: "16px",
              color: "#38bdf8",
              fontSize: "0.8rem",
              overflowX: "auto",
              maxHeight: "450px",
              whiteSpace: "pre-wrap",
              wordBreak: "break-all"
            }}
          >
            {JSON.stringify(payload, null, 2)}
          </pre>
        </div>

        <div className="modal-footer">
          <button type="button" className="topmate-btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default PayloadModal;
